import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { memo } from "react";
import type { ProductSetupConfig } from "../../registry/types";
import * as css from "./widget-completion-view.module.css";
import { WidgetConfetti } from "./widget-confetti";

export interface WidgetCompletionViewProps {
  config: ProductSetupConfig;
  /** True only on the false→true completion edge, fires the confetti once. */
  showConfetti: boolean;
  onDismiss: () => void;
}

/**
 * Minimal celebration card that replaces the task list once all
 * required-for-live tasks complete. Reads copy from `config.completion`
 * so the widget stays product-agnostic — adding a new product means
 * declaring a `completion` block in its registry config.
 */
export const WidgetCompletionView = memo(function WidgetCompletionView({
  config,
  showConfetti,
  onDismiss,
}: WidgetCompletionViewProps) {
  return (
    <div className={css.completionCard}>
      {showConfetti ? <WidgetConfetti /> : null}
      <h2 className={css.completionTitle}>{config.completion.title}</h2>
      <p className={css.completionBody}>{config.completion.body}</p>
      <div className={css.completionFooter}>
        <RedoButton
          hierarchy="primary"
          onClick={onDismiss}
          size="sm"
          text={config.completion.ctaText ?? "Got it"}
        />
      </div>
    </div>
  );
});
